export default __webpack_public_path__ + "static/media/kinetik.687e1059.PNG";